export default {
  '400.002.009': 'Merchant user email or phone already exists',
  '400.005.003': 'Refund amount more than balance amount',
  '400.005.002': 'Refund amount is negative',
  '403.008.007': 'Order balance amount is not greater than zero',
  '403.002.014':
    'Wrong Credentials. You have 4 attempts before your account is locked',
  '403.002.013':
    'Wrong Credentials. You have 3 attempts before your account is locked',
  '403.002.012':
    'Wrong Credentials. You have 2 attempts before your account is locked',
  '403.002.011':
    'Wrong Credentials. You have 1 attempts before your account is locked',
  '403.002.004':
    'Account Locked. Please use Forgot password link to reset your password.',
  'title.warnin': 'Subscription cancellation is not available',
  'resultDescription.warning':
    'Please dispatch this subscription first to activate cancellation function',
  'title.success': 'Subscription cancelled',
  'resultDescription.success':
    'Your <b>{{storeName}}</b> subscription was successfully cancelled.',
};
